export default {
  otro: 0,
  cliente: 1,
  proveedor: 2,
  compra: 3,
  venta: 4,
  prestamoConcedido: 5,
  prestamoRecibido: 6,
  interesPrestamoConcedido: 7,
  interesPrestamoRecibido: 8,
  ivaCompra: 9,
  ivaVenta: 10,
  retencionCompra: 11,
  retencionVenta: 12,
  cuentaBancaria: 13,
  comisionAperturaPrestamoConcedido: 14,
  comisionAperturaPrestamoRecibido: 15,
  comisionCorretajePrestamoConcedido: 16,
  comisionCorretajePrestamoRecibido: 17,
  comisionDisposicionPrestamoConcedido: 18,
  comisionDisposicionPrestamoRecibido: 19,
  comisionEstudioPrestamoConcedido: 20,
  comisionEstudioPrestamoRecibido: 21,
  comisionOtraPrestamoRecibido: 22,
  comisionOtraPrestamoConcedido: 23,
  ticketReembolso: 28,
}
